export default "__VITE_ASSET__BPcj6aaI__"